import React from 'react';

import { observer } from 'mobx-react-lite';
import { ShiftHistoryType } from 'stores/shift_history_store';
import useStores from 'hooks/useStores';


type ShiftHistoryContextType = {

    //    createShiftHistory: (shift: string, associated_type: string, associated_uuid: string) => Promise<ShiftHistoryType>;

    // Fetch and get one
    fetchShiftHistory: (uuid: string) => Promise<ShiftHistoryType | null>;
    getShiftHistory: (uuid: string) => ShiftHistoryType | null;

    // Fetch and get list by identity
    fetchListByIdentityShiftHistory: (identity_uuid: string, cursor: string) => Promise<ShiftHistoryType[]>;
    getListByIdentityShiftHistory: (identity_uuid: string) => ShiftHistoryType[];

    // Fetch and get list by association
    fetchListByAssociationShiftHistory: (identity: string, associated_type: string, associated_uuid: string) => Promise<ShiftHistoryType[]>;
    getListByAssociationShiftHistory: (associated_type: string, associated_uuid: string) => ShiftHistoryType[];

    // Fetch the list of all ShiftHistory items (for support)
    fetchListBySupport: (identity: string) => Promise<ShiftHistoryType[]>;

    // Contains all known ShiftHistory items
    items: ShiftHistoryType[];
}

export const ShiftHistoryContext = React.createContext<ShiftHistoryContextType>({
    //   createShiftHistory: () => { throw 'Not Implemented' },
    fetchShiftHistory: () => { throw 'Not Implemented' },
    getShiftHistory: () => { throw 'Not Implemented' },
    fetchListByIdentityShiftHistory: () => { throw 'Not Implemented' },
    getListByIdentityShiftHistory: () => { throw 'Not Implemented' },
    fetchListByAssociationShiftHistory: () => { throw 'Not Implemented' },
    getListByAssociationShiftHistory: () => { throw 'Not Implemented' },
    fetchListBySupport: () => { throw 'Not Implemented fetchListBySupport' },
    items: [] as ShiftHistoryType[],
});




export const ShiftHistoryProvider = observer(({ children }: { children: React.ReactNode }) => {

    const { shiftHistoryStore } = useStores();

    // const addItems = (newItems: ShiftHistoryType[] | ShiftHistoryType) => {
    //     // Autogenerated
    //     newItems = Array.isArray(newItems) ? newItems : [newItems];
    //     setShiftHistory([...items, ...newItems]);
    // };

    const fetchShiftHistory = async (uuid: string) => {
        // Autogenerated
        return shiftHistoryStore.fetchShiftHistory(uuid);
    };

    const getShiftHistory = (uuid: string) => {
        // Autogenerated
        return shiftHistoryStore.items.find((item) => item.uuid === uuid) || null;
    };

    const fetchListByIdentityShiftHistory = async (identity_uuid: string) => {
        // Autogenerated
        return shiftHistoryStore.fetchListByIdentityShiftHistory(identity_uuid)
            .then(() => {
                return getListByIdentityShiftHistory(identity_uuid);
            });
    };

    const fetchListBySupport = async (identity: string): Promise<ShiftHistoryType[]> => {
        return shiftHistoryStore.fetchListBySupport(identity)
            .then((items) => {
                return items;
            });
    };

    const getListByIdentityShiftHistory = (identity_uuid: string) => {
        // Autogenerated
        return shiftHistoryStore.items.slice().filter((item) => item.identity === identity_uuid);
    };


    // const createShiftHistory = async (shift: string, associated_type: string, associated_uuid: string) => {
    //     // Autogenerated
    //     return shiftHistoryStore.createShiftHistory(shift, associated_type, associated_uuid)
    //         .then((newShiftHistory) => {
    //             setShiftHistory([...items, newShiftHistory]);
    //             return newShiftHistory;
    //         });
    // };

    const fetchListByAssociationShiftHistory = async (identity: string, associated_type: string, associated_uuid: string) => {
        // Autogenerated
        return shiftHistoryStore.fetchListByAssociationShiftHistory(identity, associated_type, associated_uuid)
            .then(() => {
                return getListByAssociationShiftHistory(associated_type, associated_uuid);
            });
    };

    const getListByAssociationShiftHistory = (associated_type: string, associated_uuid: string) => {
        // Autogenerated
        return shiftHistoryStore.items.slice().filter((item) => item.associated_type === associated_type && item.associated_uuid === associated_uuid);
    };

    const data = {
        fetchShiftHistory,
        getShiftHistory,
        fetchListByIdentityShiftHistory,
        getListByIdentityShiftHistory,
        fetchListByAssociationShiftHistory,
        getListByAssociationShiftHistory,
        items: shiftHistoryStore.items,
        fetchListBySupport
    };

    return (
        <ShiftHistoryContext.Provider value={data}>{ children }</ShiftHistoryContext.Provider>
    );

});
